import React from "react";
import LoadingRedirect from "../components/LoadingRedirect";

const Status200 = () => <LoadingRedirect />;

export default Status200;